






















































































































































import Component from 'vue-class-component'
import Vue from 'vue'
import UserGroup from '@/modules/user/model/UserGroup'
import Company from '@/modules/app-router/model/Company';
import * as api from '@/modules/app-router/api'
import {Ref, Watch} from 'vue-property-decorator';
import UnigestUser from '@/modules/app-router/model/UnigestUser';
import {VForm} from '@/types';
import AppReleaseSelect from '@/modules/app-router/components/AppRelease/AppReleaseSelect.vue'
import AppRelease from '@/modules/app-router/model/AppRelease';
import {FastToken} from '@/modules/app-router/api';
import _ from 'lodash'
import KeyValuePair from '@/modules/core/support/KeyValuePair';
import {State} from 'vuex-class';
import SQLConnectionConfig from '@/modules/app-router/model/SQLConnectionConfig';

/**
 * Pantalla para realizar un inicio de sesión rápido en Unigest
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        AppReleaseSelect,
    },
})
export default class UnigestFastLogin extends Vue {
    @Ref()
    public form: VForm

    /**
     * Conexión SQL actualmente seleccionada por el usuario
     */
    @State(state => state.appRouter.currentSQLConnection)
    public currentSQLConnection: SQLConnectionConfig | null

    public get validationRules () {
        return {
            group: [
                () => !!this.group.id || 'Debes seleccionar un grupo',
            ],
            user: [
                () => !!this.user.id || 'Debes seleccionar un usuario',
            ],
        }
    }

    /**
     * Grupos de usuarios que contienen un número de serie de Unigest
     */
    public get groups () {
        const groups = this.$store.state.user.userGroups as UserGroup[]

        return groups.filter(group => (group.attributes || {})['SERIAL_NUMBER'] || null)
    }

    public group = new UserGroup()
    public companies: Company[] = []
    public company = new Company()
    public users: UnigestUser[] = []
    public user = new UnigestUser()
    public release = new AppRelease()

    public loadingCompanies = false
    public loadingUsers = false
    public loadingToken = false
    public loadingSQLConnections = false
    public window = 0
    public token = new FastToken()

    public get cardStyles () {
        const styles: KeyValuePair = {}
        if (this.$vuetify.breakpoint.xs) {
            styles.height = 'calc(100vh - 109px)'
            styles.overflow = 'auto'
        }

        return styles
    }

    public companiesFilter = (item: Company, query: string) => {
        return item.id.includes(query) || item.name.includes(query)
    }

    public usersFilter = (user: UnigestUser, query: string) => {
        return user.name.includes(query)
            || user.email.includes(query)
            || user.description.includes(query)
    }

    /**
     * Cuando el grupo seleccionado por el usuario cambia, el componente carga
     * las empresas asociadas al número de serie declarado en el nuevo
     * grupo seleccionado
     */
    @Watch('group')
    public watchGroup () {
        return Promise.all([
            this.loadCompanies(),
            this.loadUsers(),
        ])
    }


    /**
     * Cuando el componente es creado se carga la lista de grupos
     */
    public async created () {
        await Promise.all([
            this.$store.dispatch('user/loadUserGroups'),
            this.loadSQLConnections(),
        ])
    }

    /**
     * Carga en el componente la lista de empresas asociadas al grupo seleccionado por el
     * usuario
     */
    public async loadCompanies () {
        const serial = _.get(this, 'group.attributes.SERIAL_NUMBER')
        if (!serial) {
            throw new Error('El grupo no tiene número de serie asociado')
        }

        this.loadingCompanies = true
        this.companies = await api.getCompanyList(serial, this.currentSQLConnection ? this.currentSQLConnection.name : '')
        if (this.companies.length) {
            this.company = this.companies[0]
        }

        this.loadingCompanies = false
    }

    /**
     * Carga los usuarios de Unigest registrados al número de serie del grupo seleccionado
     */
    public async loadUsers () {
        const serial = _.get(this, 'group.attributes.SERIAL_NUMBER')
        if (!serial) {
            throw new Error('El grupo no tiene número de serie asociado')
        }

        this.loadingUsers = true
        this.users = await api.getUnigestUserList(serial, this.currentSQLConnection ? this.currentSQLConnection.name : '')


        const user = this.findUser('90') || this.findUser('99')
        user && (this.user = user)

        this.loadingUsers = false
    }

    /**
     * Carga la lista de conexiones SQL
     */
    public async loadSQLConnections () {
        this.loadingSQLConnections = true
        await this.$store.dispatch('appRouter/loadSQLConnections')

        this.loadingSQLConnections = false
    }

    /**
     * Inicia sesión en Unigest
     */
    public async login () {
        if (!this.form.validate()) {
            return
        }

        this.loadingToken = true

        const token = await api.getUnigestFastToken({
            company: this.company.id,
            serial: this.group.attributes['SERIAL_NUMBER'],
            user: this.user.name,
            release: this.release.id,
        })

        this.token = token
        const data = btoa(
            JSON.stringify({
                token: token.token,
                session: token.session,
                user: this.user.name,
            }),
        )

        // window.open(`http://localhost:4200?fast_token=${data}`, '_blank')

        this.loadingToken = false
        this.window = 1
    }

    public findUser (name: string) {
        return this.users.find(u => u.name === name) || null
    }

    public errorCaptured (error: Error) {
        this.loadingUsers = false
        this.loadingCompanies = false
    }
}
